import { IGetAllItemChecklistEntregaUseCase } from "../../../presentation/useCases/read/get_all_item_checklist_entrega_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";
import { ItemChecklistEntrega } from "../../models/item_checklist_entrega";

/**
 * GetAllItemChecklistEntregaUseCase
 */

export class GetAllItemChecklistEntregaUseCase
  extends BasePaginatedUseCase<ItemChecklistEntrega>
  implements IGetAllItemChecklistEntregaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async execute(
    idChecklistEntregaAmbiente: number,
    ordem?: string,
    descricao?: string,
    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {

    const result = await this.repository.getAllItemChecklistEntregas(
      idChecklistEntregaAmbiente,
      ordem,
      descricao,
      currentPage,
      rowsPerPage
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
  }
}
